import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-resident-trip-reservation-list',
	templateUrl: './resident-trip-reservation-list.component.html',
	styleUrls: ['./resident-trip-reservation-list.component.css'],
})
export class ResidentTripReservationListComponent extends ListComponent {
	protected apiUrl = 'resident/reservationTrip';

	tableRows = [
		{ id: 'reservationNumber', name: 'Rezerwacja' },
		{ id: 'name', name: 'Wycieczka' },
		{ id: 'date', name: 'Data' },
		{ id: 'amountAdult', name: 'Dorośli' },
		{ id: 'amountChild', name: 'Dzieci' },
		{ id: 'people', name: 'Uczestnicy' },
		{ id: 'comment', name: 'Uwagi do zakupu' },
	];

	protected convertData(data) {
		data.forEach((obj) => {
			obj.people = obj.people.map((item) => item.people);
		});
		return data;
	}
}
